import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaOffersEuropace, schemaOffersEuropaceSync } from '../tables';

type Arguments = {
    id: string;
    offerId: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetOfferById = z
    .discriminatedUnion('source', [
        z.object({
            offer: schemaOffersEuropace.shape.offers.element,
            source: z.literal(LOAN_REQUEST_OFFER_SOURCES.EUROPACE),
        }),
        z.object({
            offer: schemaOffersEuropaceSync.shape.offers.element,
            source: z.literal(LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC),
        }),
    ])
    .nullable();

export type SchemaLoanRequestResolver_GetOfferById = z.infer<typeof schemaLoanRequestResolver_GetOfferById>;

export type LoanRequestResolver_GetOfferById = Resolver<Arguments, SchemaLoanRequestResolver_GetOfferById>;
